<script setup lang="ts">
import SvgIcon from '@/components/common/SvgIcon.vue'
import { ESprites, ESpritesUI } from '@/shared/enum/sprites.enum'

const FUNDATION_URL = 'https://capacitateparaelempleo.org/'

const reditectToSlimFundation = () => {
  window.open(FUNDATION_URL, '_blank', 'noopener,noreferrer')
}
</script>

<template>
  <button
    id="landing-slim-fundation"
    rel="noopener noreferrer"
    data-testid="qa_landing_slim_fundation"
    class="flex flex-col items-center p-3 align-middle border rounded-lg shadow-md cursor-pointer landing__button"
    itemprop="sponsor"
    target="_blank"
    @click="reditectToSlimFundation"
  >
    <SvgIcon :file="ESprites.UI" :name="ESpritesUI.SLIM" class="w-64 h-16" />
    <span class="text-sm font-bold">Cursos gratis</span
    <meta itemprop="sponsorName" content="Fundación Carlos Slim" />
    <meta itemprop="description" content="Cursos fundación carlos slim" />
  </button>
</template>
